import { render, staticRenderFns } from "./addFreeze.vue?vue&type=template&id=1e8e5e1e&"
import script from "./addFreeze.vue?vue&type=script&lang=js&"
export * from "./addFreeze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports